import { useGetOrganization, OrganizationDto } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { env } from '@sib/config';
import { buildAgentUrl } from '@sib/utils';

const ASK_AI_ENDPOINT = '/ask-ai';

const generateAskAiUrl = (organization?: OrganizationDto): string =>
  buildAgentUrl({
    baseUrl: env.agentIframeBaseUrl,
    aiPort: organization?.aiPort,
    path: ASK_AI_ENDPOINT,
  });

export const useAskAiUrl = () => {
  const organizationId = useUserSetupStore(state => state.organization.id);
  const { data: organizationData } = useGetOrganization(organizationId);

  const isAiEnabled = organizationData?.aiEnabled ?? false;
  const askAiUrl = isAiEnabled ? generateAskAiUrl(organizationData) : null;

  return {
    isAiEnabled,
    askAiUrl,
    organizationData,
  };
};
